import React, { useEffect } from "react";
import ReactGA from "react-ga";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "react-hot-toast";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import "./App.css";
import RootRouter from "navigation/root.router";
import { AuthProvider } from "context/auth-context";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#d3a63c",
    },
    secondary: {
      main: "#8a6321",
    },
    background: {
      default: "#0f141b",
      paper: "#171c22",
    },
    text: {
      primary: "#f5efe6",
      secondary: "#c4bfb6",
    },
  },
  shape: {
    borderRadius: 16,
  },
});

const App: React.FC = () => {
  const trackingId = "G-PM606BLDCE";
  ReactGA.initialize(trackingId);

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <RootRouter />
          <Toaster
            gutter={14}
            position="top-right"
            toastOptions={{
              className: "brand-toast",
              duration: 4200,
              style: {
                background: "var(--brand-panel-muted)",
                color: "var(--brand-ink)",
                borderRadius: "22px",
                border: "1px solid var(--brand-border)",
                boxShadow: "var(--brand-shadow)",
                padding: "16px 18px",
              },
              success: {
                iconTheme: {
                  primary: "#d3a63c",
                  secondary: "#171c22",
                },
              },
              error: {
                iconTheme: {
                  primary: "var(--brand-error-border)",
                  secondary: "#fff7f7",
                },
              },
            }}
          />
        </ThemeProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
};

export default App;
